export default "__VITE_ASSET__k86fxE3b__"